import { locations } from '@/locations';
import { Card } from '@/components/ui/card';
import { Asset } from '@/types/models/assets.types';
import React from 'react';
import { useParams, generatePath } from 'react-router-dom';
import { ASSET_STUDIO, ASSETS_TYPE, FILTER_PARAMS } from '@/types/shared/navigation-tabs.enums';
import { Separator } from '@radix-ui/react-separator';
import { BodySection } from './CardSections/BodySection';
import { HeaderSection } from './CardSections/HeaderSection';
import { FooterSection } from './CardSections/FooterSection';
import { cn } from '@/lib/utils';
import { useQueryNavigation } from '@/hooks';
import { generateTestId } from '@/utils/shared/generateTestIds';

interface MachineItemProps {
  item: Asset;
  isRequireAttention?: boolean;
  isNA?: boolean;
  view?: 'list' | 'grid' | 'table';
  assetsType?: ASSETS_TYPE;
}

const componentLayout = {
  card: `w-full min-h-[100px] flex-col justify-start p-1 gap-1 flex hover:ring-primary-600 hover:ring-2 hover:cursor-pointer shadow-sm`,
  mainTitle: 'flex justify-between items-center',
  secondaryTitle: 'flex justify-between items-center',
  healthStatusIndicator: 'flex gap-2 items-center',
  assetsFaultIndicator: 'flex items-center gap-3  overflow-hidden  whitespace-nowrap pt-2 w-full',
};

const AssetsPreviewItemComponent = ({ item, isRequireAttention = false, assetsType }: MachineItemProps) => {
  const { navigateWithQuery } = useQueryNavigation();
  const { siteId } = useParams();
  const onMachineItemClick = () => {
    navigateWithQuery(generatePath(locations.protected.sites.components, { siteId, machineId: item.asset_id }), {
      addParams: { [FILTER_PARAMS.SELECTED_COMPONENT]: ASSET_STUDIO.ALL_COMPONENTS },
    });
  };

  return (
    item && (
      <Card
        onClick={onMachineItemClick}
        className={cn(componentLayout.card)}
        data-testid={generateTestId('tile_' + item.asset_ui_name)}
      >
        <div className={`p-3 ${!item.not_monitored || 'bg-gray-100 dark:bg-slate-800'}`}>
          <HeaderSection className={componentLayout.mainTitle} asset={item} assetsType={assetsType} />
          <BodySection
            asset={item}
            classNames={{ assetsFaultIndicator: componentLayout.assetsFaultIndicator }}
            isRequireAttention={isRequireAttention}
          />
          {isRequireAttention && (
            <Separator orientation="vertical" className="h-0.5 bg-gray-200 dark:bg-slate-600 mb-3" />
          )}
          {isRequireAttention && <FooterSection isRequireAttention={isRequireAttention} asset={item} />}
        </div>
      </Card>
    )
  );
};

export const AssetsPreviewItem = React.memo(AssetsPreviewItemComponent);
